/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Internal_Server_ErrorInputs */

const en_error_internal_server_error = /** @type {(inputs: Error_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal Server Error`)
};

const ar_error_internal_server_error = /** @type {(inputs: Error_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدث خطأ داخلي في الخادم`)
};

const bn_error_internal_server_error = /** @type {(inputs: Error_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সার্ভারে সমস্যা হয়েছে`)
};

const de_error_internal_server_error = /** @type {(inputs: Error_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interner Serverfehler`)
};

const es_error_internal_server_error = /** @type {(inputs: Error_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error interno del servidor`)
};

const fr_error_internal_server_error = /** @type {(inputs: Error_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur interne du serveur`)
};

const pt_error_internal_server_error = /** @type {(inputs: Error_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro interno do servidor`)
};

const zh_error_internal_server_error = /** @type {(inputs: Error_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内部服务器错误`)
};

const tr_error_internal_server_error = /** @type {(inputs: Error_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dahili Sunucu Hatası`)
};

const ru_error_internal_server_error = /** @type {(inputs: Error_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внутренняя ошибка сервера`)
};

const pl_error_internal_server_error = /** @type {(inputs: Error_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wewnętrzny błąd serwera`)
};

/**
* | output |
* | --- |
* | "Internal Server Error" |
*
* @param {Error_Internal_Server_ErrorInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const error_internal_server_error = /** @type {((inputs?: Error_Internal_Server_ErrorInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Internal_Server_ErrorInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_error_internal_server_error(inputs)
	if (locale === "bn") return bn_error_internal_server_error(inputs)
	if (locale === "de") return de_error_internal_server_error(inputs)
	if (locale === "es") return es_error_internal_server_error(inputs)
	if (locale === "fr") return fr_error_internal_server_error(inputs)
	if (locale === "pt") return pt_error_internal_server_error(inputs)
	if (locale === "zh") return zh_error_internal_server_error(inputs)
	if (locale === "tr") return tr_error_internal_server_error(inputs)
	if (locale === "ru") return ru_error_internal_server_error(inputs)
	if (locale === "pl") return pl_error_internal_server_error(inputs)
	return en_error_internal_server_error(inputs)
});